"use client";

import { useEffect, useState } from "react";
import { useRouter } from "next/navigation";
import { api, AuthUser } from "@/lib/api";

export function useAuth() {
  const router = useRouter();
  const [user, setUser] = useState<AuthUser | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const currentUser = api.getUser();
    if (!currentUser || !api.isAuthenticated()) {
      router.push("/login");
      return;
    }
    setUser(currentUser);
    setLoading(false);
  }, [router]);

  return { user, loading };
}
